
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { getEnum, getFactoryTail } from "@/service/supplier-meta/api";
import { enumToOption } from "@/utils";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
import {
  getFactorySkillDefaultValue,
  getFactorySkillOptions,
  getFactoryCategoryOptions,
  isFactorySkillCheckable,
} from "@/service/supplier-meta/common/supplier-info-service";
import { FormModel } from "@/service/common/entity/FormModel";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class DevInfo extends SupplierForm {
  form = {
    factoryInfo: {
      /** 工厂性质 */
      factoryNature: null as number | null,
      /** 工厂区域 */
      factoryArea: null as number | null,
      /** 工厂人数 */
      factoryWorkers: null as number | null,
      /** 工厂类别 */
      factoryCategory: null as number | null,
      /** 是否特殊工艺 */
      isSpecial: null as number | null,
      /** 工厂技能 */
      factorySkill: [] as number[],
      /** 做工等级 */
      workLevel: null as number | null,
      /** 尾部工厂 */
      tailFactory: null as number | null,
      /** 设备数 */
      carport: null as number | null,
      /** 自主尾整数 */
      independentAilWhole: null as number | null,
      /** 专职跟单人数 */
      fullTimeFollower: null as number | null,
      /** 专职尾查人数 */
      fullTimeTailChecker: null as number | null,
      /** 专职QC人数 */
      fullTimeQc: null as number | null,
      /** 专职生产管理人数 */
      fullTimeProductionManager: null as number | null,
      /** 专职仓储管理人数 */
      fullTimeWarehouseManager: null as number | null,
    },
  };
  factoryNatureOptions: SelectOption[] = [];
  factoryAreaOptions: SelectOption[] = [];
  factoryCategoryOptions: SelectOption[] = [];
  workLevelOptions: SelectOption[] = [];
  factoryTailOptions: SelectOption[] = [];
  factorySkillOptions: SelectOption[] = [];
  get rules(): ElementUIFormRules {
    return {
      ...this.getFieldsRules([
        "factoryInfo.factoryNature",
        "factoryInfo.factoryArea",
        "factoryInfo.factoryWorkers",
        "factoryInfo.factoryCategory",
        "factoryInfo.isSpecial",
        "factoryInfo.factorySkill",
        "factoryInfo.workLevel",
        "factoryInfo.tailFactory",
        "factoryInfo.carport",
        "factoryInfo.independentAilWhole",
        "factoryInfo.fullTimeFollower",
        "factoryInfo.fullTimeTailChecker",
        "factoryInfo.fullTimeQc",
        "factoryInfo.fullTimeProductionManager",
        "factoryInfo.fullTimeWarehouseManager",
      ]),
    };
  }
  get matchedFactoryCategoryOptions(): SelectOption[] {
    return getFactoryCategoryOptions(
      this.form.factoryInfo.factoryArea,
      this.factoryCategoryOptions
    );
  }
  get matchedFactorySkillOptions(): SelectOption[] {
    return getFactorySkillOptions(
      this.form.factoryInfo.factoryArea,
      this.form.factoryInfo.factoryCategory,
      this.factorySkillOptions
    );
  }
  get isFactorySkillCheckable() {
    return (val: number) => {
      return isFactorySkillCheckable(val);
    };
  }
  created() {
    this.getOptions();
    this.getFactoryTailOptions();
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      factoryInfo: {
        ...this.form.factoryInfo,
        factorySkill: this.form.factoryInfo.factorySkill.join(","),
      },
    };
  }
  getOptions() {
    getEnum("FactoryNatureEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.factoryNatureOptions = enumToOption(res.result);
      }
    });
    getEnum("FactoryAreaEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.factoryAreaOptions = enumToOption(res.result);
      }
    });
    getEnum("FactoryCategoryEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.factoryCategoryOptions = enumToOption(res.result);
      }
    });
    getEnum("WorkLevelEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.workLevelOptions = enumToOption(res.result);
      }
    });
    getEnum("FactorySkillEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.factorySkillOptions = enumToOption(res.result);
      }
    });
  }
  async getFactoryTailOptions(): Promise<void> {
    const res = await getFactoryTail();
    if (res?.isSuccess && Array.isArray(res.result)) {
      this.factoryTailOptions = res.result.map((r) => ({
        label: r.text,
        value: r.value,
      }));
    }
  }
  handleFactoryAreaChange(val: number): void {
    this.form.factoryInfo.factorySkill = getFactorySkillDefaultValue(
      val,
      this.form.factoryInfo.factoryCategory
    );
  }
  handleFactoryCategoryChange(val: number): void {
    this.form.factoryInfo.factorySkill = getFactorySkillDefaultValue(
      this.form.factoryInfo.factoryArea,
      val
    );
  }
  patchFormData(fd: FormModel) {
    super.patchFormData(fd);
    const data = fd as unknown as SupplierInfoSubmitBO;
    this.form.factoryInfo.factorySkill =
      data.factoryInfo?.factorySkill?.split(",").map((s) => +s) || [];
  }
}
